/**
 * elkészíti (vagy ha már van akkor nem nyúl hozzá) az angularos app-ot
 * ha függőség kell még hozzá akkor azt például így kell az adott helyen hozzácsapni:
 * $EBIZ.requires.push('chart.js');
 * @author laci
 */

export default function (dependencies) {
	var defaultDependencies = ['frameContextModule', 'pageContextModule', 'ui.router', 'ngSanitize', 'ngAnimate', 'ui.bootstrap', 'ui.bootstrap.carousel',
		'angularFileUpload', 'ngTagsInput', 'ui.select', 'checklist-model', 'ngCookies', 'naif.base64', 'ngMessages', 'ngIdle', 'dynamicNumber',
		'sticky', 'LocalStorageModule', 'environmentModule'];

	if (dependencies) {
		defaultDependencies = defaultDependencies.concat(dependencies);
	}

	try {
		angular.module('translateContextModule');
		defaultDependencies.push('translateContextModule');
	} catch (err) {
		angular.noop(err);
	}

	window.$EBIZ = window.$EBIZ || angular.module('EBIZ', defaultDependencies).value('$anchorScroll', angular.noop);
	return window.$EBIZ;
}
